import React, { Component } from 'react';
import { scrollToTopOf } from '../../utils';

class ArticleContentNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sticky: false,
      menuOpen: false,
      active: 'menu',
    };

    this.handleScroll = this.handleScroll.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  handleScroll() {
    const desktopHeaderHeight = 65;
    const { isMobile, contentHeaderBottom, hasContentHeader } = this.props;
    const height = this.navRef.clientHeight;
    if (!isMobile) {
      contentHeaderBottom < (height + desktopHeaderHeight) ? this.setState({sticky: true}) : this.setState({sticky: false});
    } else return;
  }

  handleClick(navLink, offset, active) {
    if (!navLink && !active) {
      this.setState({menuOpen: !this.state.menuOpen});
      this.setState({active: 'menu'});
    } else {
      scrollToTopOf(navLink, offset);
      this.setState({active: active});
      this.setState({ menuOpen: !this.state.menuOpen });
    }
  }

  componentDidMount() {
    const { isMobile } = this.props;
    
    isMobile ? this.setState({sticky: true}) : null;

    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', this.handleScroll);
    }
    if (!this.props.isMobile) {
      this.setState({menuOpen: true});
    }
  }

  componentDidUpdate() {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', this.handleScroll);
    }
  }

  render() {
    const { navs, isMobile, hasContentHeader } = this.props;
    const { sticky, menuOpen, active } = this.state;
    const buildContentNav = () => {
      const getDataId = (d) => {
        let dId = null;
        try {
          dId = d.replace(/[\W_]+/g, '').replace(/\s+/g, '-').toLowerCase();
        } catch (e) {
          console.log(e);
        } finally {
          return dId;
        }
      }
      const navItems = navs.map(nav => {
        const dataId = getDataId(nav.data);
        if (dataId) {
          const navLink = `#${dataId}`;
          const offset = sticky ? 180 : 200;
          return (<a className={nav.data === active ? 'active' : ''} onClick={() => this.handleClick(navLink, offset, nav.data)}>{nav.data}</a>);
        } else {
          return null;
        }
        
      });
      const contentNav = (
        <div className={`content-hub-nav ${this.state.sticky ? 'sticky' : ''}`} ref={navRef => {this.navRef = navRef}}>
          {isMobile && <a className={active === 'menu' ? 'menu active' : 'menu'} onClick={() => this.handleClick()}>+ menu</a>}
          {isMobile ? menuOpen && navItems : navItems}
        </div>
      );
      return contentNav;
    }
    const renderedArticleContentNav = buildContentNav();
    return (<div className={`content-nav-container ${this.state.sticky && hasContentHeader ? 'sticky' : ''}`}>{renderedArticleContentNav}</div>);
  }

}

export default ArticleContentNav;
